import {
    CHARMS_USAGE_SELECTION_TYPE,
    CHARMS_USAGE_SOURCE_CALENDARPICKERCONTEXTMENU,
    charmsDatapoints,
} from 'owa-calendar-charms-store';

import { getCalendarEntry } from 'owa-calendar-cache';
import { logUsage } from 'owa-analytics';
import { orchestrator } from 'satcheljs';
import { setCalendarCharm } from '../actions/calendarActions';
import { updateCalendarCharm } from 'owa-calendar-update';

orchestrator(setCalendarCharm, async actionMessage => {
    const { iconId, calendar } = actionMessage;

    let calendarEntry = getCalendarEntry(calendar);
    const { customData } = charmsDatapoints.CharmsDatapoint.charmselectiondatapoint;
    logUsage(
        CHARMS_USAGE_SELECTION_TYPE,
        customData('Manual', iconId, CHARMS_USAGE_SOURCE_CALENDARPICKERCONTEXTMENU)
    );

    await updateCalendarCharm({
        FolderId: calendarEntry.FolderId,
        CharmId: iconId,
    });
});
